// Paleta central do painel. FONTE ÚNICA das cores de interface: o tema MUI (routes.js)
// lê daqui e `aplicarCoresCss()` publica as mesmas cores como variáveis CSS (--cor-*)
// para os .css e estilos inline. Não repita hex destas cores em outros arquivos.
//
// Vermelho de MARCA (cabeçalho, botões principais, item selecionado do menu) e vermelho
// de ERRO (excluir, cancelar, falhas) são cores DIFERENTES de propósito: a marca não
// deve parecer erro. O tema MUI usa estas cores FIXAS (não lê mais as cores do app do
// estabelecimento em aplicativoCF).
export const CORES = {
    marca: "#A92E32",
    marcaHover: "#8C2529",
    marcaRgb: "169, 46, 50",
    secundaria: "#30343B",
    fundo: "#F6F6F6",
    superficie: "#FFFFFF",

    menuFundo: "#30343B",
    menuTexto: "#D5D8DD",
    menuTextoAtivo: "#FFFFFF",

    sucesso: "#28A745",
    // Erro/ação destrutiva (excluir, cancelar, falha). Use var(--cor-erro) /
    // var(--cor-erro-hover) e, com transparência, rgba(var(--cor-erro-rgb), α).
    erro: "#DC3545",
    erroHover: "#B02A37",
    erroRgb: "220, 53, 69",

    // Botões verdes de ação (Salvar, Adicionar, Confirmar…): verde mais fechado/sóbrio que o
    // de status. Use var(--cor-botao-salvar) / var(--cor-botao-salvar-hover) e, para sombra,
    // rgba(var(--cor-botao-salvar-rgb), α).
    botaoSalvar: "#2E7D32",
    botaoSalvarHover: "#256B29",
    botaoSalvarRgb: "46, 125, 50",

    // Advertências financeiras (fatura, inadimplência): âmbar, nunca o vermelho de erro.
    alertaFinanceiroFundo: "#FFF4E5",
    alertaFinanceiroTexto: "#7A4510",
    alertaFinanceiroBorda: "#F3C98B",
} as const

export type NomeCor = keyof typeof CORES

const nomeVariavel = (nome: string) => "--cor-" + nome.replace(/[A-Z]/g, l => "-" + l.toLowerCase())

/** `var(--cor-...)` da cor, para estilos inline/JSS. */
export const corCss = (nome: NomeCor) => `var(${nomeVariavel(nome)})`

/** Publica a paleta como variáveis CSS no :root (ex.: --cor-menu-fundo). */
export function aplicarCoresCss() {
    const raiz = document.documentElement.style
    Object.entries(CORES).forEach(([nome, valor]) => raiz.setProperty(nomeVariavel(nome), valor))
}
